class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.renderRecommendation(parsedState);

      if (this.header) this.header.reveal();
      this.open();
  }

  renderRecommendation(parsedState) {
    const container = document.getElementById('cart-notification-recommendation');
    if (!container) return;

    // The template is only on the page when the current product template has the
    // "Cart recommendation" section with a product selected.
    const template = document.querySelector('template[data-cart-recommendation]');
    container.innerHTML = '';

    if (!template || String(parsedState.product_id) === template.dataset.productId) {
      container.hidden = true;
      return;
    }

    container.appendChild(template.content.cloneNode(true));
    container.hidden = false;

    const form = container.querySelector('[data-cart-recommendation-form]');
    if (form) form.addEventListener('submit', this.onRecommendationSubmit.bind(this));
  }

  onRecommendationSubmit(evt) {
    evt.preventDefault();
    const form = evt.currentTarget;
    const submitButton = form.querySelector('[type="submit"]');
    const errorMessage = form.querySelector('.cart-recommendation__error');
    if (submitButton.getAttribute('aria-disabled') === 'true') return;

    submitButton.setAttribute('aria-disabled', true);
    errorMessage.hidden = true;

    const formData = new FormData(form);
    formData.append('sections', this.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);

    fetch(form.action, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          errorMessage.textContent = response.description || response.message;
          errorMessage.hidden = false;
          return;
        }

        this.renderContents(response);
        trapFocus(this.notification);
      })
      .catch((e) => console.error(e))
      .finally(() => submitButton.removeAttribute('aria-disabled'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
